import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import Layout from './components/Layout'
import ProtectedRoute from './components/ProtectedRoute'
import NotificationContainer from './components/NotificationContainer'
import Home from './pages/Home'
import Login from './pages/Login'
import Register from './pages/Register'
import Dashboard from './pages/Dashboard'
import AuthCallback from './pages/AuthCallback'
import PendingApproval from './pages/PendingApproval'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import { WebSocketProvider } from './contexts/WebSocketContext'
import { NotificationProvider } from './contexts/NotificationContext'
import { IoTProvider } from './contexts/IoTContext'
import { USER_ROLES } from './utils/roleUtils'

// Componente que maneja las rutas con autenticación
function AppRoutes() {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    )
  }

  return (
    <Layout>
      <Routes>
        {/* Rutas públicas */}
        <Route 
          path="/login" 
          element={user ? <Navigate to="/dashboard" replace /> : <Login />} 
        />
        <Route 
          path="/register" 
          element={user ? <Navigate to="/dashboard" replace /> : <Register />} 
        />
        <Route path="/auth/callback" element={<AuthCallback />} />
        
        {/* Rutas protegidas */}
        <Route 
          path="/" 
          element={
            user ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <Navigate to="/login" replace />
            )
          } 
        />
        
        <Route 
          path="/pending-approval" 
          element={
            <ProtectedRoute requiredRole={USER_ROLES.PENDING_APPROVAL}>
              <PendingApproval />
            </ProtectedRoute>
          } 
        />
        
        <Route 
          path="/dashboard" 
          element={
            user ? (
              <ProtectedRoute requiredRole={USER_ROLES.USER}>
                <Dashboard />
              </ProtectedRoute>
            ) : (
              <Navigate to="/login" replace />
            )
          } 
        />
        
        {/* Ruta por defecto */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  )
}

function App() {
  return (
    <NotificationProvider>
      <AuthProvider>
        <WebSocketProvider>
          <IoTProvider>
            <Router>
              <AppRoutes />
              <NotificationContainer />
            </Router>
          </IoTProvider>
        </WebSocketProvider>
      </AuthProvider>
    </NotificationProvider>
  )
}

export default App